import { useLocation, useNavigate } from 'react-router-dom';
import { useShellContext } from '@/app/shell/AppShell';
import { RouteRecoveryScreen } from '@/app/states/RouteStates';
import { useSpendByCategory } from '@/api/hooks/useSpendByCategory';
import { SpendAggregationSurface } from './SpendAggregationSurface';
import { ViewSwitcher } from './ViewSwitcher';
import { DateScopeGuard } from '@/app/shell/DateScopeGuard';
import { hrefForSpendDrilldown } from './transactionDrillIn';

function CategoriesPageContent() {
  const {
    accountIds,
    dateFrom: scopeFrom,
    dateTo: scopeTo,
    scopeAvailability,
    retryScopeAvailability,
  } = useShellContext();
  const location = useLocation();
  const navigate = useNavigate();
  const spend = useSpendByCategory({
    accountIds: accountIds ?? [],
    dateFrom: scopeFrom,
    dateTo: scopeTo,
    enabled: scopeAvailability === 'ready',
  });

  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return <RouteRecoveryScreen kind="offline" frame="inline" />;
  }

  if (scopeAvailability !== 'ready') {
    return (
      <p role="status" className="mt-4 rounded-md border border-border bg-muted/30 p-4 text-sm text-muted-foreground">
        {scopeAvailability === 'pending' ? (
          'Checking transaction scope availability…'
        ) : (
          <>
            Transaction scope availability could not be checked.{' '}
            <button type="button" className="min-h-11 rounded-md border border-input px-3 underline" onClick={retryScopeAvailability}>
              Retry
            </button>
          </>
        )}
      </p>
    );
  }

  return (
    <SpendAggregationSurface
      mode="category"
      spend={spend}
      onDrilldown={(descriptor) => {
        navigate(hrefForSpendDrilldown(location.search, location.hash, descriptor));
      }}
    />
  );
}

export function CategoriesPage() {
  const { dateScopeAvailability } = useShellContext();
  return (
    <section aria-labelledby="by-category-heading" className="mx-auto w-full max-w-5xl p-4">
      <h1 id="by-category-heading" tabIndex={-1} className="text-title font-semibold">Transactions</h1>
      <ViewSwitcher />
      <DateScopeGuard availability={dateScopeAvailability}>
        <CategoriesPageContent />
      </DateScopeGuard>
    </section>
  );
}

export default CategoriesPage;
